import { irwin } from 'config'
import { httpClient } from './httpClient'
import Jsona, { SwitchCaseJsonMapper } from 'jsona'

const deserializer = new Jsona({
  jsonPropertiesMapper: new SwitchCaseJsonMapper({ switchChar: '_' }),
})

function client() {
  return httpClient(irwin.baseUrl)
}

async function createCustomerSublocation({ customerLocationId, sublocationId }) {
  const response = await client().post('v2/customer_sublocations', {
    customer_location_id: customerLocationId,
    sublocation_id: sublocationId,
  })
  return deserializer.deserialize(response)
}

async function deleteCustomerSublocation(id) {
  await client().delete(`v2/customer_sublocations/${id}`)
}

export { createCustomerSublocation, deleteCustomerSublocation }
